<script lang="ts" setup>
	defineProps<{
		progress: number
	}>()
</script>

<template>
	<div class="min-h-[82px] w-full max-w-[273px] rounded-md border px-3 py-5">
		<h4 class="mb-5 font-medium text-gray-600 lg:text-base"> {{ progress < 100 ? progress : 100 }}% complete </h4>

		<div class="progress-wrapper h-[9px] w-full max-w-full overflow-hidden rounded-lg bg-[#DAF1EB]">
			<div
				class="h-[inherit] rounded-[inherit] bg-primary-2 transition-[500ms]"
				:style="{ width: `${progress}%` }"
			/>
		</div>
	</div>
</template>
